import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCoupling = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.80005 5.60001H6.20005V18.1M1.80005 18.1H9.60005",
			stroke: "CurrentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.7 19.6C19.8 19.6 20.7 18.7 20.7 17.6C20.7 16.5 19.8 15.6 18.7 15.6C17.6 15.6 16.7 16.5 16.7 17.6C16.7 18.7 17.6 19.6 18.7 19.6Z",
			stroke: "CurrentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.6 17.6H14.7V6.60001C14.7 6.30001 14.8 6.10001 15 5.90001C15.2 5.70001 15.4 5.60001 15.7 5.60001H22.4M20.7 17.6H22.3",
			stroke: "CurrentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.40002 11.4C9.60002 11.4 10.9 11.4 12.1 11.4",
			stroke: "CurrentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.2 9.10001L12 11.4",
			stroke: "CurrentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3 13.8L12 11.4",
			stroke: "CurrentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCoupling;
